import { Controller } from "@hotwired/stimulus"

// Click-and-drag horizontal scrolling for rows whose scrollbar is hidden
// (finance tab rows — Phelipe 2026-08-05). Links inside still click
// normally: the drag only takes over after ~4px of movement, and the
// click that would fire after a real drag is swallowed.
export default class extends Controller {
  connect() {
    this._down = this._down.bind(this)
    this._move = this._move.bind(this)
    this._up = this._up.bind(this)
    this._click = this._click.bind(this)
    this._dragstart = this._dragstart.bind(this)
    this.element.addEventListener("mousedown", this._down)
    this.element.addEventListener("click", this._click, true)
    this.element.addEventListener("dragstart", this._dragstart)
  }

  disconnect() {
    this.element.removeEventListener("mousedown", this._down)
    this.element.removeEventListener("click", this._click, true)
    this.element.removeEventListener("dragstart", this._dragstart)
    window.removeEventListener("mousemove", this._move)
    window.removeEventListener("mouseup", this._up)
  }

  _down(e) {
    if (e.button !== 0) return
    this._pressed = true
    this._dragging = false
    this._startX = e.clientX
    this._startLeft = this.element.scrollLeft
    window.addEventListener("mousemove", this._move)
    window.addEventListener("mouseup", this._up)
  }

  _move(e) {
    if (!this._pressed) return
    const dx = e.clientX - this._startX
    if (!this._dragging && Math.abs(dx) < 4) return
    this._dragging = true
    this.element.scrollLeft = this._startLeft - dx
    e.preventDefault()
  }

  _up() {
    this._pressed = false
    window.removeEventListener("mousemove", this._move)
    window.removeEventListener("mouseup", this._up)
    // The click event lands right after mouseup — let _click see the drag
    // flag first, then clear it.
    setTimeout(() => { this._dragging = false }, 0)
  }

  _click(e) {
    if (!this._dragging) return
    e.preventDefault()
    e.stopPropagation()
  }

  // A drag that starts on a link would otherwise become a native
  // link-drag ghost — suppress it while the row is pressed.
  _dragstart(e) {
    if (this._pressed) e.preventDefault()
  }
}
